module.exports = "<div class=\"track master-track\">\n  <md-toolbar class=\"track-toolbar\">\n    <div class=\"md-toolbar-tools\">\n\n      <h4 class=\"track-key system-text\">\n        <span>Master</span>\n      </h4>\n      <span flex class=\"flex\"></span>\n     \n    </div>\n  </md-toolbar>\n  <md-content class=\"track-content\" flex>\n    <textarea ui-codemirror=\"{ onLoad : vm.codemirrorLoaded }\" ui-codemirror-opts=\"{{vm.options}}\" ng-model=\"vm.master.part\">\n    </textarea>\n  </md-content>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/web/main/track/master-track.html
// module id = 186
// module chunks = 0